module.exports = __webpack_public_path__ + "img/code.477ab4a2.jpg";